import { Button } from '@alto/design-system';
import { useNavigation } from '@alto/navigation';
import * as React from 'react';
import { getCompanyName } from '~shared/config/getCompanyName';
import { COMMS_CHANNEL, IMG_ALT_TEXTS } from '~shared/constants';
import { CommsVerificationCard } from './CommsVerificationCard';
import { Image } from '~web/components/Image';
import checkmark from '~web/images/verifiedCheckmark@2x.png';

export type Props = {
  readonly commsChannel: string;
  readonly authorized: boolean;
};

export const CommsVerificationSuccess = ({ authorized, commsChannel }: Props) => {
  const { navigate } = useNavigation();

  const navigateToNextRoute = () => {
    if (authorized) {
      navigate('RouteAppTabNavigator', { screen: 'RouteTabMyMeds' });
    } else {
      navigate('RouteLogin');
    }
  };

  return (
    <CommsVerificationCard
      headerIcon={
        <Image
          sidebar
          src={checkmark}
          alt={IMG_ALT_TEXTS.greenCheckmark}
        />
      }
      title={`${COMMS_CHANNEL[commsChannel as keyof typeof COMMS_CHANNEL]} verified!`}
    >
      <Button
        onPress={navigateToNextRoute}
        label={`Continue to ${getCompanyName()}`}
        accessibilityLabel={`Continue to ${getCompanyName()}`}
        width="full"
      />
    </CommsVerificationCard>
  );
};
